export const CHANGE_CARD_INDEX = 'CHANGE_CARD_INDEX';
export const CHANGE_CARD_MENU_INDEX = 'CHANGE_CARD_MENU_INDEX';
export const CHANGE_ROW_INDEX = 'CHANGE_ROW_INDEX';
export const UPDATE_SHOW_INFO = 'UPDATE_SHOW_INFO';
export const TOGGLE_CASTS = 'TOGGLE_CASTS';
